import { FC } from 'react';
import { BackButton } from '@dynamika-shared/ui/BackButton/BackButton';
import { StatusPill } from '@dynamika-shared/ui/StatusPill/StatusPill';
import { PatientUploadStatusEnum } from '@dynamika-shared/types/status';
import { d7Format } from '@dynamika-shared/utils/date';

interface SubjectDetailsPatientProps {
  patientCode: string;
  dob?: string;
  status?: PatientUploadStatusEnum;
  siteName?: string;
  cohortId?: string;
  onBack: () => void;
}


export const SubjectDetailsPatient: FC<SubjectDetailsPatientProps> = ({
  patientCode,
  status,
  dob,
  siteName,
  cohortId,
  onBack,
}) => {
  const formattedDob = dob ? d7Format(dob, 'MMM-yyyy') || dob : '-';

  return (
    <div className='flex items-center justify-between py-4'>
      <div className='info flex items-center gap-[.5rem]'>
        <BackButton action={onBack} />

        <h2 className='leading-40 text-left text-[3.6rem] font-semibold tracking-normal flex flex-col justify-center min-h-[100px] ml-[10px]'>
          <div className='flex items-center gap-2 h-[50px] mr-[20px]'>
            <span className='leading-[48px]'>
              {patientCode}
            </span>
          </div>
        </h2>

        {status && (
          <div className='status flex items-center'>
            <StatusPill status={status} className='m-0' />
          </div>
        )}
      </div>

      <div className='flex items-center gap-1 flex-wrap'>
        <div className='flex items-center gap-[0.25rem] text-1624 text-dimGray h-[32px]'>
          <span className='flex items-center h-full'>Date of Birth:</span>
          <div className='relative h-[32px] flex items-center'>
            <div className='w-full h-full'>
              <div className='flex items-center justify-between gap-2 w-full h-[32px] px-1 rounded text-black text-1624'>
                <span className='leading-[32px]'>{formattedDob}</span>
              </div>
            </div>
          </div>
        </div>
        <div className='h-[20px] w-[2px] border-r-2' />

        <div className='text-1624 text-dimGray flex items-center gap-[0.25rem] h-[32px]'>
          <span className='pl-2 block'>Site:</span>
          <div className='inline-flex items-center gap-2 h-[32px] px-1 rounded text-black text-1624'>
            <span className='truncate leading-[32px] text-black'>
              {siteName}
            </span>
          </div>
        </div>

        <div className='h-[20px] w-[2px] border-r-2' />

        <div className='text-1624 text-dimGray flex items-center gap-[0.25rem] h-[32px]'>
          <span className='pl-2 block'>Cohort:</span>
          <div
            className='inline-flex items-center gap-2 h-[32px] px-1 rounded text-black text-1624'>
            <span className='truncate leading-[32px] text-black'>
              {cohortId || '-'}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};
